import {
	ClusterOutlined,
	HomeOutlined,
	TagOutlined,
	AppstoreOutlined,
	PlusCircleOutlined,
	SisternodeOutlined,
	GiftOutlined,
	WalletOutlined,
	TagsOutlined,
	EnvironmentOutlined,
	TruckOutlined,
	CloudDownloadOutlined,
	SettingOutlined,
	NotificationOutlined,
	MessageOutlined,
	DeleteOutlined,
	FileDoneOutlined,
	UnorderedListOutlined,
	BarChartOutlined,
	UserOutlined,
	MailOutlined,
	QrcodeOutlined,
} from '@ant-design/icons';
import {ColorModeContext} from 'Helpers/contexts';
import Icon from '@ant-design/icons/lib/components/Icon';
import SVGDualTone from 'Components/Shared/SVGDualTone';
import shipingchargesIcon from 'Static/img/shippingchargesicon.svg';
import menuManagementIcon from 'Static/img/menu_management_logo.svg';
import productsSectionIcon from 'Static/img/product_section_logo.svg';
import manageMediaIcon from 'Static/img/manage_media.svg';
import featuredCategoryIcon from 'Static/img/featured_category.svg';
import websiteTcon from 'Static/img/website_logo.svg';
import crmIcon from 'Static/img/crmIcon.svg';
import crmIconDarkMode from 'Static/img/crmIcondarkMode.svg';
import {useContext} from 'react';
import {KycAdminPaths} from 'Router/KYCAdminPaths';
import {Paths} from 'Router/Paths';
import searchByMiscIcon from 'Static/img/searchmisc.svg';
import KycIcon from 'Static/img/KYC.svg';
import Reports from 'Static/KYC_STATIC/img/kyc_report_icon.svg';
import DocUpdateIcon from 'Static/KYC_STATIC/img/doc_update.svg';
import UpdateRequestIcon from 'Static/KYC_STATIC/img/update-request.svg';
import KycHistoryIcon from 'Static/KYC_STATIC/img/kyc-history.svg';
import BulkOperationsIcon from 'Static/KYC_STATIC/img/bulk-operations.svg';
import KycTrackIcon from 'Static/KYC_STATIC/img/kyc-track.svg';
import MiscellaneousIcon from 'Static/KYC_STATIC/img/miscellaneous.svg';
import MisIcon from 'Static/KYC_STATIC/img/mis.svg';
import EnableIcon from 'Static/img/enableIcon.svg';
import FinanceIcon from 'Static/img/finance-icon.svg';
import abAccountingIcon from 'Static/img/ab_accounting_icon.svg';
import KYCIcon from 'Static/KYC_STATIC/img/kyc_icon.svg';
import defaultIcon from 'Static/img/defaultIcon.svg';
import genieIcon from 'Static/img/genie.svg';
import {getTodayDateDDMMYYYY} from './functions';
import dayjs from 'dayjs';

export const CONSISTENCY_WALLET_CODE = 107;
export const BASE_URL = 'http://localhost:3000/quotes-api';

export const MOBILE_WIDTH = 800; // px

export const ORDERBOOK_LEVELS = 25; // rows count

export const MESSAGES = {
	SUCCESS_LOGIN: 'Login Successfully !',
	API_ERROR: 'Something Went wrong !',
	OTP_SUCCESS: 'OTP Sent Successfully !',
	OTP_VALID: 'OTP Is Valid !',
	RESEND_OTP: 'OTP Resend Successfully !',
	OTP_NOT_VALID: 'OTP Is Not Valid !',
	PASSOWRD_CHANGED: 'Password Change Successfully !',
	PROFILE_UPDATED: 'Profile Updated Successfully',
	DOCUMENT_UPDATED: 'Documents Uploaded Successfully',
	REQUEST_SEND: 'Request Send Successfully',
	SETTINGS_UPDATED: 'Settings Updated Successfully',
	SETTINGS_UPDATE_FAIL: 'Failed To Update Settings',
	SETTINGS_ADDED: 'Setting Added Successfully',
	NOT_REQUIRED_PERMISSIONS: "You don't have required permissions",
};
export const LoginModuleError = {
	MOBILENUMBEREQUIRED: 'Mobile number is required',
	MOBILENUMBERLENGTH: 'Mobile number must be of 10 digit.',
	MOBILENUMBERREGIXMESSAGE: 'Invalid mobile number.',
	OTPREQUIRED: 'OTP is required',
	OTPINVALID: 'OTP is Invalid',
	ENTEROTP: 'Please enter otp',
	PASSWORDREQUIRED: 'Password is required',
	CONFIRMPASSWORDREQUIRED: 'Confirm Password is required',
	MOBILENUMBEREGIX: /^[0-9_]+$/,
};

export const RULES_MESSAGES = {
	NO_WHITE_SPACE_MESSAGE: 'Please ensure there are no spaces at the beginning or end',
	MIN_MAX_LENGTH_MESSAGE: 'The value must be between 1 and 50 characters long.',
	MIN_MAX_LENGTH_MESSAGE_FN: (min, max) => `The value must be between ${min} and ${max} characters long.`,
	CONSECUTIVE_SPACE_MESSAGE: 'Please do not enter more than one consecutive space',
	THREE_To_FIFTY_CHARACTERS_LENGTH: 'The value must be between 3 and 50 characters long.',
};

export const STATUS = {
	PENDING: 'PENDING',
	SENT: 'SENT',
	EXPIRED: 'EXPIRED',
	NEGOTIATING: 'NEGOTIATING',
	ORDER_SUBMITTED: 'ORDER SUBMITTED',
	REJECTED: 'REJECTED',
	COMPLETED: 'COMPLETED',
};

export const ROLE = {
	DEALER: 'DEALER',
	INVESTOR: 'INVESTOR',
};

export const snackBarSuccessConf = {
	variant: 'success',
	anchorOrigin: {vertical: 'top', horizontal: 'right'},
};

export const snackBarErrorConf = {
	variant: 'error',
	anchorOrigin: {vertical: 'top', horizontal: 'right'},
};

export const snackBarSuccessConfV2 = (duration = 10000) => ({
	...snackBarSuccessConf,
	autoHideDuration: duration, // for 10 seconds
});

export const snackBarInfoConf = {
	variant: 'info',
	anchorOrigin: {vertical: 'top', horizontal: 'right'},
};
export const snackBarWarningConf = {
	variant: 'warning',
	anchorOrigin: {vertical: 'top', horizontal: 'right'},
};

/**
 * Function to return Icon According to MenuList and breadcrumb Icon
 * @param {*} icon
 * @returns
 */

const IconRenderer = ({svgElement}) => <SVGDualTone svgElement={svgElement} />;

const ShippingPriceIcon = props => (
	<Icon component={() => <IconRenderer svgElement={shipingchargesIcon} />} {...props} />
);
const MenuManagementIcon = props => (
	<Icon component={() => <IconRenderer svgElement={menuManagementIcon} />} {...props} />
);
const ProductsSectionIcon = props => (
	<Icon component={() => <IconRenderer svgElement={productsSectionIcon} />} {...props} />
);

const MangeMediaIcon = props => <Icon component={() => <IconRenderer svgElement={manageMediaIcon} />} {...props} />;

const FeaturedCategoryIcon = props => (
	<Icon component={() => <IconRenderer svgElement={featuredCategoryIcon} />} {...props} />
);

const WebsiteIcon = props => <Icon component={() => <IconRenderer svgElement={websiteTcon} />} {...props} />;
const CrmIconImage = props => {
	const {mode} = useContext(ColorModeContext);

	return <Icon component={() => <IconRenderer svgElement={mode ? crmIcon : crmIconDarkMode} />} {...props} />;
};

const AbAccountingIcon = props => (
	<Icon
		className="ab-accounting-menu-icon"
		component={() => <IconRenderer svgElement={abAccountingIcon} />}
		{...props}
	/>
);

const customSvgIcon = (icon, props) => <Icon component={() => <IconRenderer svgElement={icon} />} {...props} />;

export const returnMenuIcon = icon => {
	if (icon === 'dashboard') {
		return <HomeOutlined />;
	} else if (icon === 'category') {
		return <ClusterOutlined />;
	} else if (icon === 'user') {
		return <UserOutlined />;
	} else if (icon === 'tags') {
		return <TagOutlined />;
	} else if (icon === 'Brands') {
		return <AppstoreOutlined />;
	} else if (icon === 'attributes') {
		return <PlusCircleOutlined />;
	} else if (icon === 'variants') {
		return <SisternodeOutlined />;
	} else if (icon === 'products') {
		return <GiftOutlined />;
	} else if (icon === 'wallet') {
		return <WalletOutlined />;
	} else if (icon === 'Offer&Coupon') {
		return <TagsOutlined />;
	} else if (icon === 'pincodeStore') {
		return <EnvironmentOutlined />;
	} else if (icon === 'cso') {
		return <TruckOutlined />;
	} else if (icon === 'shippingPrice') {
		return <ShippingPriceIcon />;
	} else if (icon === 'downloads') {
		return <CloudDownloadOutlined />;
	} else if (icon === 'configurations') {
		return <SettingOutlined />;
	} else if (icon === 'manageNotification') {
		return <NotificationOutlined />;
	} else if (icon === 'menuManagement') {
		return <MenuManagementIcon />;
	} else if (icon === 'productsSection') {
		return <ProductsSectionIcon />;
	} else if (icon === 'featuredCategory') {
		return <FeaturedCategoryIcon />;
	} else if (icon === 'manageMedia') {
		return <MangeMediaIcon />;
	} else if (icon === 'abMessage') {
		return <MessageOutlined />;
	} else if (icon === 'website') {
		return <WebsiteIcon />;
	} else if (icon === 'CRM') {
		return <CrmIconImage />;
	} else if (icon === 'no') {
		return null;
	} else if (icon == 'searchab') {
		return customSvgIcon(searchByMiscIcon);
	} else if (icon == 'delete-outlined') {
		return <DeleteOutlined />;
	} else if (icon == 'kyc-icon') {
		return customSvgIcon(KycIcon);
	} else if (icon == 'reports') {
		return customSvgIcon(Reports);
	} else if (icon == 'declaration') {
		return <FileDoneOutlined />;
	} else if (icon == 'list') {
		return <UnorderedListOutlined />;
	} else if (icon == 'doumentUpdate') {
		return customSvgIcon(DocUpdateIcon);
	} else if (icon == 'updateRequest') {
		return customSvgIcon(UpdateRequestIcon);
	} else if (icon == 'history') {
		return customSvgIcon(KycHistoryIcon);
	} else if (icon == 'bulkOperations') {
		return customSvgIcon(BulkOperationsIcon);
	} else if (icon == 'kycTrack') {
		return customSvgIcon(KycTrackIcon);
	} else if (icon == 'miscellaneous') {
		return customSvgIcon(MiscellaneousIcon);
	} else if (icon == 'mis') {
		return customSvgIcon(MisIcon);
	} else if (icon == 'enableInfo') {
		return customSvgIcon(EnableIcon);
	} else if (
		icon === 'abAccounting' ||
		icon === 'account_circle' ||
		icon === 'accounting' ||
		icon === 'ab_accounting'
	) {
		return <AbAccountingIcon />;
	} else if (icon == 'finance-icon') {
		return customSvgIcon(FinanceIcon);
	} else if (icon == 'barChart') {
		return <BarChartOutlined />;
	} else if (icon == 'kyc-admin') {
		return customSvgIcon(KYCIcon);
	} else if (icon === 'mail') {
		return <MailOutlined />;
	} else if (icon === 'qr') {
		return <QrcodeOutlined />;
	} else if (icon === 'genie') {
		return customSvgIcon(genieIcon);
	} else {
		return customSvgIcon(defaultIcon);
	}
};

export const tabletWidth = 1024;

/**
 * This will be used for BRANDS, CATS, PRODUCTS,
 */
export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'video/mp4'];

export const ALLOWED_IMAGES_GIF = ['image/jpeg', 'image/png', 'video/mp4', 'image/gif'];

/**
 * This will be used for BRANDS, CATS, PRODUCTS,
 */
export const ALLOWED_FILE_IMAGE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

/**
 * This will be used for SIZE CALCULATION IN MB
 */
export const ALLOWED_FILE_SIZE = 5;
export const ALLOWED_FILE_SIZE_FOR_SVG = 3;
export const ALLOWED_UPLOAD_FILES_AB_SCHEDULED_MESSAGES = ['image/jpeg', 'image/png', 'image/jpg'];
export const ALLOWED_FILE_SIZE_FOR_AB_SCHEDULED_MESSAGES = 5; // 5MB

export const REQUIERD_MESSAGES = {
	variant_attr: {
		message: 'Attribute Value is required',
		placeholder: 'Enter Attribute Value',
	},
};
export const PermissionAction = {
	ADD: 'add',
	EDIT: 'edit',
	VIEW: 'view',
	DELETE: 'delete',
	DOWNLOAD: 'download',
	UPLOAD: 'upload',
	IMPORT: 'import',
	EXPORT: 'export',
	BULK_DELETE: 'bulk_delete',
	BULK_DOWNLOAD: 'bulk_download',
	BULK_UPLOAD: 'bulk_upload',
	BULK_IMPORT: 'bulk_import',
	BULK_EXPORT: 'bulk_export',
	ALLOW_UPDATE_PRODUCT_STATUS: 'allow_update_product_status',
	CREATE: 'create',
	GENERATE_REFUND: 'generate_refund',
};

export const productSampleSheetData = {
	productSheet: [
		{
			'SAP Code': '10001',
			Type: 'Master',
			Name: 'T-Shirt',
			Brand: 'Polo',
			'Dispatch By': 'HO',
			Weight: '1000',
			'Net Content': '1',
			Barcode: '123456789',
			'New Arrival': '0',
			// //"Short Description": "it is a long established fact that a reader will be distracted by the readable con",
			'Full Description':
				't is a long established fact that a reader will be distracted by the readable t is a long established fact that a reader will be distracted by the readable con',
			Category: "Man's Shirt",
			'Min Cart Quantity': '2',
			'Max Cart Quantity': '10',
			'Meta Title': 'Test title',
			'Meta Description': 'Test Desc',
			'Meta Keyword': 'shirt, polo shirt',
			'HSN Number': '999999',
			GST: '8',
			'GST Exempted': 1,
			'Purchase Price': '100',
			MRP: '150',
			'Shipping Price': '20',
			'Sale Price': '130',
			'Purchase Volume': '40',
			'Same Price For All State': '0',
			Parent: '',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Red, Blue, White',
			'Attribute 1 visible': '1',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'S,M,L,XL',
			'Attribute 2 visible': '1',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10002',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			Barcode: '',
			'Net Content': '1',
			'New Arrival': '0',
			// //"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Red',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'S',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10003',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Red',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'M',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10004',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Red',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'L',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10005',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Red',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'XL',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10006',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Blue',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'S',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10007',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Blue',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'L',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10008',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'Blue',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'XL',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10009',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'White',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'S',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10010',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'White',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'M',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10011',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'White',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'L',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
		{
			'SAP Code': '10012',
			Type: 'Variant',
			Name: '',
			Brand: '',
			'Dispatch By': '',
			'New Arrival': '0',
			'Net Content': '1',
			//"Short Description": "",
			'Full Description': '',
			Category: '',
			'Min Cart Quantity': '',
			'Max Cart Quantity': '',
			'Meta Title': '',
			'Meta Description': '',
			'Meta Keyword': '',
			'HSN Number': '',
			GST: '',
			'GST Exempted': 1,
			'Purchase Price': '',
			MRP: '',
			'Shipping Price': '',
			'Sale Price': '',
			'Purchase Volume': '',
			'Same Price For All State': '',
			Parent: '10001',
			'Attribute 1 name': 'Color',
			'Attribute 1 value(s)': 'White',
			'Attribute 1 visible': '',
			'Attribute 2 name': 'Size',
			'Attribute 2 value(s)': 'XL',
			'Attribute 2 visible': '',
			'Product Image Link':
				'https://danceloveinclusive.com/cdn/shop/products/mens-classic-tee-red-front-642818f9c5dae_1100x.jpg?v=1680716439, https://rukminim2.flixcart.com/image/850/1000/l37mtu80/t-shirt/g/g/n/s-amg-43-tshirt-fastb-original-imagedkgecxmfzmg.jpeg?q=90&crop=false',
		},
	],
	productStateSheet: [
		{
			'SAP Code': '10001',
			State: 'Rajasthan',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
		{
			'SAP Code': '10001',
			State: 'Gujarat',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
		{
			'SAP Code': '10001',
			State: 'Haryana',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
		{
			'SAP Code': '10001',
			State: 'Himachal Pradesh',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
		{
			'SAP Code': '10001',
			State: 'Jammu and Kashmir',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
		{
			'SAP Code': '10001',
			State: 'Karnataka',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
		{
			'SAP Code': '10001',
			State: 'Kerala',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
		{
			'SAP Code': '10001',
			State: 'Madhya Pradesh',
			'Sale Price': '130',
			'PV Price': '40',
			'Shipping Price': '20',
		},
	],
};
export const bulkUploadSampleData = [
	{
		'SAP Code': '10001',
		'Purchase Volume': '40',
	},
	{
		'SAP Code': '10002',
		'Purchase Volume': '20.45',
	},
];

export const updatePriceBulkUpload = [
	{
		'SAP Code': '10001',
		MRP: '129',
		SP: '23',
		PV: '40',
		// NP: "95",
		'Is SP/PV Same In All States': '0',
		'Effective Date': getTodayDateDDMMYYYY(),
	},
	{
		'SAP Code': '10002',
		MRP: '123',
		SP: '25',
		PV: '35',
		// NP: "95",
		'Is SP/PV Same In All States': '1',
		'Effective Date': getTodayDateDDMMYYYY(),
	},
];

export const statePriceBulkUpload = [
	{'SAP Code': '10001', State: 'ANDAMAN AND NICOBAR ISLANDS', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Andhra Pradesh', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Arunachal Pradesh', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Assam', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Bihar', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Chandigarh', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'CHHATTISGARH', SP: '130', PV: '40'},
	{
		'SAP Code': '10001',
		State: 'DAMAN AND DIU',
		SP: '130',
		PV: '40',
	},
	{'SAP Code': '10001', State: 'Delhi', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Goa', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Gujarat', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Haryana', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Himachal Pradesh', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Jammu and Kashmir', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Jharkhand', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Karnataka', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Kerala', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Lakshadweep', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Madhya Pradesh', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Maharashtra', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Manipur', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Meghalaya', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Mizoram', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Nagaland', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Odisha', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'PUDUCHERRY', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Punjab', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Rajasthan', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Sikkim', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Tamil nadu', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Telangana', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Tripura', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Uttarakhand', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'Uttar Pradesh', SP: '130', PV: '40'},
	{'SAP Code': '10001', State: 'West Bengal', SP: '130', PV: '40'},
];

export const instructionsUpdatePrice = [
	{
		'Column Name': 'SAP Code',
		Description: 'This is the unique SAP code assigned to the master product. It should be numeric.',
	},
	{
		'Column Name': 'MRP',
		Description: 'Enter the MRP for the SAP Code. It should be numeric.',
	},
	{
		'Column Name': 'SP',
		Description: 'Enter the Selling Price for the SAP Code. It should be numeric.',
	},
	{
		'Column Name': 'PV',
		Description: 'Enter the Purchase Volume for the SAP code. It will be a numeric value.',
	},
	{
		'Column Name': 'NP',
		Description:
			'Enter the Special Price for the SAP code. It should be numeric and greater than or equal to zero.',
	},

	{
		'Column Name': 'Is SP/PV Same In All States',
		Description: 'Enter the Is SP/PV Same In All States for the SAP code. It will be either 0(No) or 1(Yes).',
	},

	{
		'Column Name': 'Effective Date',
		Description:
			'Enter the Effective Date for the SAP code. It should be of Date type in dd/mm/yyyy format and cannot be in the past.',
	},
];

export const updateProductsBulkUpload = [
	{
		sap_code: '21321123',
		stores: 'enable',
		app: 'disable',
		web: 'enable',
		status: 'active',
	},
	{
		sap_code: '21321124',
		stores: 'disable',
		app: 'enable',
		web: 'enable',
		status: 'inactive',
	},
	{
		sap_code: '21321125',
		stores: '',
		app: 'enable',
		web: '',
		status: 'active',
	},
];

export const instructionsUpdateProducts = [
	{
		'Column Name': 'sap_code',
		Description: 'Unique SAP Code or Material ID of the product. Must be numeric and unique. (Required)',
	},
	{
		'Column Name': 'stores',
		Description:
			"Enable or disable visibility in Stores. Allowed values: 'enable' or 'disable'. Leave blank to keep existing value without updating.",
	},
	{
		'Column Name': 'app',
		Description:
			"Enable or disable visibility in Mobile App. Allowed values: 'enable' or 'disable'. Leave blank to keep existing value without updating.",
	},
	{
		'Column Name': 'web',
		Description:
			"Enable or disable visibility on Website. Allowed values: 'enable' or 'disable'. Leave blank to keep existing value without updating.",
	},
	{
		'Column Name': 'status',
		Description:
			"Product status. Allowed values: 'active', 'inactive', or 'discontinued'. Leave blank to keep existing value without updating.",
	},
];

export const mappedSheetData = {
	mappedSheet: [
		{
			'AB ID': '123',
			Amount: '2342',
			Remark: 'Test',
		},
		{
			'AB ID': '321',
			Amount: '3215',
			Remark: 'Test',
		},
	],
};

export const pincodeSheetData = {
	pincodeSheet: [
		{
			'Store Name': 'test store name 1',
			Pincode: 302001,
			'Store Code': 12345678,
		},
		{
			'Store Name': 'test store name 2',
			Pincode: 302002,
			'Store Code': 12345678,
		},
		{
			'Store Name': 'test store name 3',
			Pincode: 302003,
			'Store Code': 12345678,
		},
		{
			'Store Name': 'test store name 4',
			Pincode: 302004,
			'Store Code': 12345678,
		},
		{
			'Store Name': 'test store name 5',
			Pincode: 302005,
			'Store Code': 12345678,
		},
	],
};

/*export const ABSheetData = {
  ABSheet: [
    {
      "Dist No": 7894561
      // "Registration ID": 651651,
      // Status: "Active"
    },
    {
      "Dist No": 5252633
      // "Registration ID": 65165,
      // Status: "Inactive"
    },
    {
      "Dist No": 1254563
      // "Registration ID": 132,
      // Status: "active"
    }
  ],
  AssociateBuyerSheet: [
    { "Associate Buyer": 1001 },
    { "Associate Buyer": 1002 },
    { "Associate Buyer": 1003 },
    { "Associate Buyer": 1004 },
    { "Associate Buyer": 1005 }
  ],
  AssociateBuyerBulkSheet: [{ "Associate Buyer": 10452, Remark: "Bank Enabled" }],
  BulkSmsSheet: [
    {
      mobile_no: 9988897854,
      var1: "IFSC Code",
      var2: "",
      var3: "",
      var4: "",
      var5: ""
    },
    {
      mobile_no: 8487438897,
      var1: "",
      var2: "Customer ID",
      var3: "",
      var4: "",
      var5: ""
    }
  ]
};*/

export const ABSheetData = {
	ABSheet: [
		{
			'Dist No': 5115,
		},
		{
			'Dist No': 51315,
		},
		{
			'Dist No': 123,
		},
	],
	AssociateBuyerSheet: [
		{'Associate Buyer': 1001},
		{'Associate Buyer': 1002},
		{'Associate Buyer': 1003},
		{'Associate Buyer': 1004},
		{'Associate Buyer': 1005},
	],
	AssociateBuyerBulkSheet: [{'Associate Buyer': 10452, Remark: 'Bank Enabled'}],
	BulkSmsSheet: [
		{
			mobile_no: 9988897854,
			var1: 'IFSC Code',
			var2: '',
			var3: '',
			var4: '',
			var5: '',
		},
		{
			mobile_no: 8487438897,
			var1: '',
			var2: 'Customer ID',
			var3: '',
			var4: '',
			var5: '',
		},
	],
};

/**
 * function to validate password match
 * @param {*} param0
 * @returns
 */
export const passwordMatchedValidator = ({getFieldValue}) => ({
	validator(_, value) {
		if (!value || getFieldValue('password') === value) {
			return Promise.resolve();
		}

		return Promise.reject('Confirm password not matched !');
	},
});

/**
 * function to validate password match
 * @param {*} param0
 * @returns
 */
export const confirmPasswordMatchedValidator = ({getFieldValue}) => ({
	validator(_, value) {
		if (!value || getFieldValue('confirm_password') === value) {
			return Promise.resolve();
		}

		return Promise.reject(' password not matched !');
	},
});

/**
 * function to validate mobile number
 * @param {*} _
 * @param {*} value
 * @returns
 */
export const validateMobile = (_, value) => {
	if (value && (value.length < 10 || value.length > 10)) {
		return Promise.reject(LoginModuleError.MOBILENUMBERLENGTH);
	}

	if (value && !LoginModuleError.MOBILENUMBEREGIX.test(value)) {
		return Promise.reject(LoginModuleError.MOBILENUMBERREGIXMESSAGE);
	}

	return Promise.resolve();
};

/**
 * function  to validate otp
 * @param {*} _
 * @param {*} value
 * @returns
 */
export const validateOTP = (_, value) => {
	if (!value || value.includes(undefined) || value.includes('')) {
		return Promise.reject(LoginModuleError.OTPINVALID);
	}

	return Promise.resolve();
};

export const depotList = [
	{
		value: 'delhi',
		label: 'Delhi',
	},
	{
		value: 'jaipur',
		label: 'Jaipur',
	},
	{
		value: 'noida',
		label: 'Noida',
	},
];

export const dispatchBy = [
	{label: 'PUC', value: 'PUC'},
	{label: 'Depot', value: 'Depot'},
	// { label: "Head Office", value: "HO" }
];

export const otherUsergroup = [
	{label: 'All', value: 'all'},
	{label: 'DIST', value: 'DIST'},
	{label: 'CUST', value: 'CUST'},
	{label: 'REG', value: 'REG'},
	{label: 'DEPO', value: 'DEPO'},
	{label: 'PUC', value: 'PUC'},
	{label: 'BZR', value: 'BZR'},
	{label: 'WW', value: 'WW'},
	{label: 'WWQ', value: 'WWQ'},
	{label: 'WWP', value: 'WWP'},
	{label: 'PAINT', value: 'PAINT'},
	{label: 'KSO', value: 'KSO'},
	{label: 'DW', value: 'DW'},
];

// Used in Dispatch By feild (Shipping Charges Module)
export const pucUsergroup = [
	{label: 'All', value: 'all'},
	{label: 'DIST', value: 'DIST'},
	{label: 'CUST', value: 'CUST'},
	{label: 'REG', value: 'REG'},
];

export const PUC_BUYER_TYPE = [
	{label: 'DIST', value: 'DIST'},
	{label: 'CUST', value: 'CUST'},
	{label: 'REG', value: 'REG'},
	{label: 'DW', value: 'DW'},
];

export const userDownloadGroup = [
	{label: 'All', value: 'all'},
	// { label: "DIST", value: "DIST" },
	// { label: "CUST", value: "CUST" },
	// { label: "REG", value: "REG" },
	// { label: "DEPO", value: "DEPO" },
	// { label: "PUC", value: "PUC" },
	// { label: "BZR", value: "BZR" },
	{label: 'WW', value: 'wonder_world'},
	{label: 'WWQ', value: 'wonder_world_quick'},
	{label: 'WWP', value: 'wonder_world_prime'},
	{label: 'PAINT', value: 'paint'},
	{label: 'KSO', value: 'keysoul_store'},
	{label: 'DW', value: 'display_wall'},
	{label: 'PUC', value: 'puc'},
];

export const paymentMethods = [
	// { label: "All", value: "all" },
	{label: 'Online Payment (Prepaid)', value: 'prepaid'},
	// { label: "Pick up at Nearest Store", value: "pick up at nearest store" },
	{label: 'Cash On Delivery (COD)', value: 'cod'},
];

export const whiteSpaceDecimalandValueGreaterthanZERO = [
	{pattern: /^\S(.*\S)?$/, message: RULES_MESSAGES.NO_WHITE_SPACE_MESSAGE},
	{
		pattern: /^[1-9]\d*$/,
		message: 'Value must be greater than 0 and decimal value is not allowed',
	},
];

export const shippingChargeOptions = [
	{label: 'Price', value: 'price'},
	// { label: "Weight", value: "weight" },
	{label: 'Always', value: 'always'},
];

export const productExportKeys = [
	'SAP Code',
	'Type',
	'Name',
	'Brand',
	'Barcode',
	'Dispatch By',
	'New Arrival',
	'Weight',
	'Net Content',
	'Short Description',
	'Full Description',
	'Category',
	'Min Cart Quantity',
	'Max Cart Quantity',
	'Meta Title',
	'Meta Description',
	'Meta Keyword',
	'HSN Number',
	'GST',
	'GST Exempted',
	'Purchase Price',
	'MRP',
	'Shipping Price',
	'Sale Price',
	'Purchase Volume',
	'Same Price For All State',
	'Parent',
	'Attribute 1 name',
	'Attribute 1 value(s)',
	'Attribute 1 visible',
	'Attribute 2 name',
	'Attribute 2 value(s)',
	'Attribute 2 visible',
	'Attribute Display Order',
	'Images',
];

export const allSupportedStores = ['wonder_world', 'wonder_world_quick', 'keysoul_store', 'display_wall'];

export const categorySheetData = {
	categorySheet: [
		{
			'Category Name': 'Test Category',
			'Display Order': 1,
			// "Is Featured": 0,
			Description: "Category's description",
			Status: 'active',
			// "Show On Type": "web" + "," + "app",
			// "Supported Stores": "wonder_world" + "," + "wonder_world_quick" + "," + "keysoul_store" + "," + "display_wall",
			'Parent Category': '',
			'Category Image': 'https://picsum.photos/200',
			'Banner Image': 'https://picsum.photos/200',
			'Banner Mobile Image': 'https://picsum.photos/200',
		},
	],
};

export const brandSheetData = {
	brandSheet: [
		{
			'Brand name': 'Test Brand',
			Description: "Brand's description",
			'Brand Logo Image': 'https://picsum.photos/200',
			'Banner Image': 'https://picsum.photos/200',
			'Banner Mobile Image': 'https://picsum.photos/200',
			Status: 'active',
		},
	],
};

export const sliderTypeOptions = [
	{label: 'URL', value: 'url'},
	// { label: "API", value: "api" },
	{label: 'PAGE', value: 'page'},
	{label: 'MESSAGE', value: 'message'},
	{label: 'YOUTUBE LINK', value: 'youtube_url'},
];

export const webORAppOptions = [
	{label: 'Web', value: 'web'},
	{label: 'App', value: 'app'},
	// { label: "Both", value: "both" }
];

export const settingTypeOptions = [
	{label: 'Text', value: 'text'},
	{label: 'Switch', value: 'switch'},
	{label: 'Number', value: 'number'},
	{label: 'Image', value: 'image'},
	{label: 'Editor', value: 'editor'},
];
export const settingTypeEcomOptions = [
	{label: 'Text', value: 'text'},
	{label: 'Number', value: 'number'},
];

export const advancedExampleData = {
	dummyId: 1,
	dummyInfo: {email: 'fake1@example.com', phone: '79000000001'},
	role: 'dummy role',
	maxLength: 15,
	minLength: 2,
	prefix: false,
	suffix: false,
};

export const generalExampleData = {
	dummyId: 1,
	dummyInfo: {email: 'fake1@example.com', phone: '79000000001'},
	role: 'dummy role',
};
export const generalSettings = {
	email: 'fake1@example.com',
	phone: '79000000001',
};

export const DATEFORMAT = {
	RANGE_FORMAT: 'DD-MM-YYYY',
	MONTH_FORMAT_DASH: 'DD-MMMM-YYYY',
	MONTH_FORMAT: 'DD/MMM/YYYY',
	COMMON_FORMAT: 'YYYY-MM-DD',
};

export const menuTupeOptions = [
	{
		label: 'Category',
		value: 'Category',
	},
	{
		label: 'Category Mega Menu',
		value: 'Category Mega Menu',
	},
	{
		label: 'Brand',
		value: 'Brand',
	},
	{
		label: 'Link',
		value: 'Link',
	},
	{
		label: 'Page',
		value: 'Custom',
	},
];

export const productSectionSheetData = {
	productSectionSheet: [
		{
			'SAP Code': '999999',
		},
	],
};

export const SECTION_CATEGORY = [
	{
		label: 'Trending',
		value: 'is_trending',
	},
	{
		label: 'Featured',
		value: 'is_featured',
	},
	{
		label: 'Promotion',
		value: 'is_promotion',
	},
];

export const pageSizeOptions = ['5', '10', '20', '50', '100'];

export const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

export const valueUptoTwoDecimalValueRegex = /^\d*(\.\d{0,2})?$/;

// exclude path

export const excludedPaths = [
	'product_add',
	'product_edit',
	'keysoul-template',
	'crm',
	'crm-order-view',
	'orders',
	'order-view',
	...Object.values(KycAdminPaths),
];

// excludedBreadCrumb
export const excludedBreadCrumb = [
	'crm',
	...Object.values(KycAdminPaths),
	Paths.accountSummary,
	Paths.completeLedger,
	Paths.abRemainingBalance,
	Paths.abTdsTracker,
	Paths.panCases,
	Paths.reversePayment,
	Paths.reversePaymentUpload,
	Paths.abHolds,
	Paths.commissionCycle,
	Paths.businessProcessing,
	Paths.abInvoices,
	Paths.bankBookSummary,
	Paths.bankBookDetails,
	Paths.sbiBankBookDetails,
	Paths.masterRcmBank,
	Paths.paymentRelease,
];

export const typesOfOffer = [
	{
		value: 'buy_x_get_y_free',
		label: 'Buy X Qty Get Y Qty Free',
	},
	{
		value: 'buy_x_amount_of_products_and_get_a_product_free',
		label: 'Buy X amount of Product and get a product free',
	},
	{
		value: 'buy_x_amount_of_products_and_get_a_product_on_y_prices_or_get_y%_discount',
		label: 'Buy X amount of Products and get A product on Y prices or get Y% discount',
	},
	{
		value: 'bundle_deal',
		label: 'Bundle Deal / Progressive Deal',
	},
	{
		value: 'buy_x_get_y_eligible',
		label: 'Buy X[ ], Get Y Eligible',
	},
	// {
	//   value: "free_shipping",
	//   label: "Free Shipping"
	// },
	{
		value: 'default_offer',
		label: 'Default',
	},
];

export const supportedStoresOptions = [
	{label: 'Wonder World', value: 'wonder_world'},
	{label: 'Wonder World Quick', value: 'wonder_world_quick'},
	{label: 'Wonder World Prime', value: 'wwp'},
	{label: 'Paint', value: 'paint'},
	{label: 'Keysoul Store', value: 'keysoul_store'},
	{label: 'Display Wall', value: 'display_wall'},
	{label: 'Puc', value: 'puc'},
];

export const applicableBuyerType = [
	{label: 'DIST (Associate Buyer)', value: 'DIST'},
	{label: 'CUST (Customer Buyer)', value: 'CUST'},
	{label: 'REG (Register Buyer)', value: 'REG'},
	{label: 'DW (Display Wall)', value: 'DW'},
	{label: 'Wonder World Prime', value: 'WWP'},
	{label: 'Paint', value: 'PAINT'},
	{label: 'Wonder World Quick', value: 'WWQ'},
	{label: 'Wonder World', value: 'WW'},
	{label: 'PUC', value: 'PUC'},
	{label: 'Keysoul', value: 'KSO'},
];

export const GST_VALUES = [
	{label: 0, value: 0},
	{label: 5, value: 5},
	{label: 12, value: 12},
	{label: 18, value: 18},
];
export const APPLICABLE_ON_TYPES = [
	{value: 'all', label: 'All'},
	{value: 'brands', label: 'Brand'},
	{value: 'categories', label: 'Category'},
];

// Function to format labels
export const formatLabel = label => {
	return label
		.replace(/_/g, ' ') // Replace underscores with spaces
		.replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
};

export const RESOURCE_TYPES = [
	{
		value: 'pos',
		label: 'POS',
	},
	{
		value: 'e-com',
		label: 'E-COM',
	},
];

export const RESORCE_USER_TYPES = [
	{
		value: 'keysoul_store',
		label: 'Keysoul Store',
	},
	{
		value: 'wonder_world',
		label: 'Wonder World',
	},
	{
		value: 'wonder_world_quick',
		label: 'Wonder World Quick',
	},
	{
		value: 'display_wall',
		label: 'Display Wall',
	},
];

export const DISCOUNT_TYPE = [
	{
		value: 'percentage',
		label: 'Percentage',
	},
	{
		value: 'fixed',
		label: 'Fixed',
	},
];

export const PROGRAM_TYPE = [
	{
		value: 'rcm_zonal_celebration_program',
		label: 'RCM ZONAL CELEBRATION PROGRAM',
	},
	{
		value: 'rcm_ulp_program',
		label: 'RCM ULP PROGRAM',
	},
	{
		value: 'rcm_food_festival',
		label: 'RCM FOOD FESTIVAL',
	},
];

export const WALLET_TYPES = [
	{value: 'brand', label: 'Brand'},
	{value: 'category', label: 'Category'},
	{value: 'product', label: 'Product'},
	{value: 'generic', label: 'Generic'},
];

export const MEETING_TYPE = [
	{
		value: 'wwq',
		label: 'WWQ',
	},
	{
		value: 'open',
		label: 'OPEN',
	},
];

export const URL_VALIDATION_REGEX =
	/^(https?:\/\/)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(:\d+)?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/;

export const templateOptions = [
	{label: 'Default', value: 'default'},
	{label: 'Keysoul', value: 'keysoul'},
];

export const FALL_BACK =
	'data:image/png;base64,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';

export const NOTICESSHOWONLIST = [
	{label: 'Default', value: 'default'},
	{label: 'Keysoul', value: 'keysoul'},
];

export const KYC_TERMINATE_REMARK = [
	{label: 'Document are incorrect', value: 'Document are incorrect'},
	{label: 'Image are not clear', value: 'Image are not clear'},
];
export const USER_STATUS = {
	ACTIVE: 'Active',
	INACTIVE: 'Inactive',
};

export const E_KYC_LIST_TYPE = [
	{
		label: 'E-Registration',
		value: 'e_registration',
	},
	{
		label: 'E-Registration Edit',
		value: 'e_registration_edit',
	},
	{
		label: 'ID Activation',
		value: 'id_activation',
	},
	{
		label: 'Account Check',
		value: 'account_check',
	},
	{
		label: 'Old KYC',
		value: 'old_kyc',
	},
	{
		label: 'Auto Check',
		value: 'auto_check',
	},
];

// This method will return the Months array
export const getMonths = () => {
	return [
		{value: 1, label: 'January'},
		{value: 2, label: 'February'},
		{value: 3, label: 'March'},
		{value: 4, label: 'April'},
		{value: 5, label: 'May'},
		{value: 6, label: 'June'},
		{value: 7, label: 'July'},
		{value: 8, label: 'August'},
		{value: 9, label: 'September'},
		{value: 10, label: 'October'},
		{value: 11, label: 'November'},
		{value: 12, label: 'December'},
	];
};

// This method will return the last 100 years from CURRENT YEAR...
export const getYears = () => {
	let startYear = new Date().getFullYear();
	const years = [{value: startYear, label: startYear}];
	for (let index = 1; index < 100; index++) {
		years.push({value: startYear - index, label: startYear - index});
	}
	return years;
};

// KYC Status

export const KYC_STATUS = {
	OK: 'KYC OK',
	NOT: 'KYC NOT OK',
};

export const abNoMaxLength = 18;
export const aadharNumberMaxLength = 12;
export const emailMaxLength = 50;
export const languageOption = [
	{
		label: 'English',
		value: 1,
	},
	{
		label: 'Hindi',
		value: 2,
	},
];

export const monthsArray = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

// dummy data for sms diamond club demo sheet

export const SMS_EXPORT_DATA = [
	{'Mobile Number': '7615811280'},
	{'Mobile Number': '7737640687'},
	{'Mobile Number': '8209372075'},
];

// Meeting Type

export const MEETING_TYPE_KEY = {
	WWQ: 'wwq',
	ULP_QUICK: 'ulp_quick',
};

// MEETING STATUS => USED IN (AB MODULE : CHECK MONTHLY MEETING)
export const MEETING_STATUS = {
	APPROVED: 'approved',
	REJECTED: 'rejected',
};

export const ALLOWED_UPLOAD_FILES = ['image/jpeg', 'image/png', 'image/jpg'];
export const ALLOWED_UPLOAD_FILES_PROFILE_MENU = ['image/svg+xml'];
export const USER_TYPES = ['DIST', 'CUST', 'REG', 'DEPOT', 'PUC', 'BZR', 'WW', 'WWQ', 'KSO'];
export const DEVICE_TYPES = ['web', 'app'];

export const RejectionReason = {Other: 15};

export const batchTypes = [
	{label: 'Buniyaad', value: 'Buniyaad'},
	{label: 'Main', value: 'Main'},
	{label: 'Sewa', value: 'Sewa'},
	{label: 'Udaan', value: 'Udaan'},
	{label: 'Sehat Mitra', value: 'Sehat Mitra'},
];

export const MDM_PAGINATION = ['5', '10', '20', '50'];
export const abBankDetails = {
	bank_name: {
		fieldName: 'bank_code',
		validations: [
			{
				required: true,
				message: `Bank Name is required`,
			},
		],
	},
	branch_state: {
		fieldName: 'branch_state_code',
		validations: [
			{
				required: true,
				message: `Branch State is required`,
			},
		],
	},
	branch_name: {
		fieldName: 'branch_name',
		validations: [
			{
				required: true,
				message: `Branch Name is required`,
			},
		],
	},
	bank_acc_no: {
		fieldName: 'bank_acc_no',
	},
	bank_proof: {
		fieldName: 'bank_proof',
		validations: [
			{
				required: true,
				message: `Bank Account Proof Photo is required`,
			},
		],
	},
};

export const monthsMapping = {
	1: 'jan',
	2: 'feb',
	3: 'mar',
	4: 'apr',
	5: 'may',
	6: 'jun',
	7: 'jul',
	8: 'aug',
	9: 'sep',
	10: 'oct',
	11: 'nov',
	12: 'dec',
};

export const monthOptions = [
	{label: 'January', value: 1},
	{label: 'February', value: 2},
	{label: 'March', value: 3},
	{label: 'April', value: 4},
	{label: 'May', value: 5},
	{label: 'June', value: 6},
	{label: 'July', value: 7},
	{label: 'August', value: 8},
	{label: 'September', value: 9},
	{label: 'October', value: 10},
	{label: 'November', value: 11},
	{label: 'December', value: 12},
];

export const bankAccountNumberValidation = {
	regex: new RegExp(/^(?=.*[1-9]).*$/),
	message: 'Bank account number must contain at least one non-zero digit',
};

export const STORES = {
	keysoul_store: 'Keysoul Store',
	wonder_world: 'Wonder World',
	wonder_world_quick: 'Wonder World Quick',
	display_wall: 'Display Wall',
	wwp: 'Wonder World Prime',
	PAINT: 'Paint',
	puc: 'PUC',
};

export const CART_TYPE = {
	PUC: 'puc',
	DEPOT: 'depot',
};

export const BUSINESS_GENERATION_STEPS = {
	BASE_STEP: 'base_step',
	PERFORMANCE_CALCULATED: 'performance_calculated',
	PROCESS_STARTED: 'process_started',
	GENERATED_NET_AMT: 'generated_net_amt',
	PIPELINE_ENV_INITIALIZED: 'pipeline_env_initialized',
	STAGING_CLEARED: 'staging_cleared',
	SYNCING_OLD_PAN: 'syncing_old_pan',
	OLD_PAN_SYNCED: 'old_pan_synced',
	PAN_USERS_HELD: 'pan_users_held',
	TDS_TRACKER_REBUILT: 'tds_tracker_rebuilt',
	NEW_ACCOUNT_STAGED: 'new_account_staged',
	COMMISSION: 'commission',
	PAN_SYNC: 'pan_sync',
	PAN_SYNCED: 'pan_synced',
	TDS_SYNC: 'tds_sync',
	GST_SYNC: 'gst_sync',
	BANK_DETAILS_HOLD: 'bank_details_hold',
	FINAL_PAY_GENERATED: 'final_pay_generated',
	INVOICES_GENERATED: 'invoices_generated',
	LEDGER_PROMOTED: 'ledger_promoted',
	FINAL_BUSINESS_CALCULATED: 'invoices_generated',
};
export const TDS_DESCRIPTION = 'tds added';

export const CONSISTENCY_GENERATION_STEPS = {
	PROCESS_STARTED: 'PROCESS_STARTED',
	FETCHING_DATA: 'FETCHING_DATA',
	INSERTING_DATA: 'INSERTING_DATA',
	FINAL_CONSISTENCY_DATA_GENERATED: 'FINAL_CONSISTENCY_DATA_GENERATED',
	FAILED: 'FAILED',
	DEFAULT_MESSAGE: 'Generation in progress...',
};

export const CASH_BONUS_GENERATION_STEPS = {
	PROCESS_STARTED: 'PROCESS_STARTED',
	FETCHING_DATA: 'FETCHING_DATA',
	INSERTING_DATA: 'INSERTING_DATA',
	FINAL_CASH_BONUS_DATA_GENERATED: 'FINAL_CASH_BONUS_DATA_GENERATED',
	FAILED: 'FAILED',
	DEFAULT_MESSAGE: 'Generation in progress...',
};

export const CASH_BONUS_CYCLE_STEPS = {
	BASE_STEP: 'BASE_STEP',
	BASE_INSERTED: 'FINAL_CASH_BONUS_DATA_INSERTED',
	PREREQUISITES_SYNCED: 'prerequisites_synced',
	CALCULATED_AND_STAGED: 'calculated_and_staged',
	INVOICES_GENERATED: 'invoices_generated',
	CASH_BONUS_FINALIZED: 'cash_bonus_finalized',
};

export const KYC_SCHEDULE_MAINTENANCE = 'kyc-schedule-maintenance';
export const KYC_MDM_SCHEDULE_MAINTENANCE = 'kyc-mdm-schedule-maintenance';
export const ECOM_MDM_SCHEDULE_MAINTENANCE = 'ecom-mdm-schedule-maintenance';

// Converts 12-hour time (e.g. "02:30 PM") to total minutes
const timeStringToMinutes = t => {
	if (!t) return 0; // fallback
	const [time, modifier] = t.split(' ');
	let [hours, minutes] = time.split(':').map(Number);
	if (modifier == 'PM' && hours != 12) hours += 12;
	if (modifier == 'AM' && hours == 12) hours = 0;
	return hours * 60 + minutes;
};

// Sorts objects by time in ascending order
export const timeSorter = (a, b) => timeStringToMinutes(a.time) - timeStringToMinutes(b.time);

export const Price_obj = {
	MRP: 'MRP',
	SP: 'S.P.',
	PV: 'P.V.',
	NP: 'N.P.',
};

export const bankAccountLengthOptions = [
	{label: '9', value: 9},
	{label: '10', value: 10},
	{label: '11', value: 11},
	{label: '12', value: 12},
	{label: '13', value: 13},
	{label: '14', value: 14},
	{label: '15', value: 15},
	{label: '16', value: 16},
	{label: '17', value: 17},
	{label: '18', value: 18},
];

export const SYMBOL_EXCLUDED_KEY = ['E-Mail', 'Mobile Update Limit'];

export const ACTION_OPTIONS = [
	{label: 'Death Case', value: 'death_case'},
	{label: 'ID Transfer', value: 'id_transfer'},
];

export const MAX_LENGTH = {
	ADDRESS: 500,
	CITY_TEHSIL_POST: 100,
	NAME: 100,
};

export const MIN_LENGTH = {
	ADDRESS: 10,
	CITY_TEHSIL_POST: 2,
};

export const MISCELLANEOUS = {
	KYC_REGISTERED_BUYER: 'kyc_miscellaneous_registered_buyer',
	KYC_NORMAL_BUYER: 'kyc_miscellaneous_normal_buyer',
	KYC_DUPLICATE_RECORD: 'kyc_miscellaneous_duplicate_records',
	RB_REPURCHASE: 'rb_repurchase',
	NB_REPURCHASE: 'nb_repurchase',
	AB_SPONSOR_ALLOW_MISUSE: 'ab_sponsor_allow_misuse',
	INACTIVE_REGISTERED_BUYER: 'kyc_miscellaneous_inactive_registered_buyer',
};

export const KYC_TRACKS = {
	KYC_MASTER_AB_DETAILS: 'kyc_master_ab_details_tracks',
	TERMINATION_HISTORY: 'kyc_termination_history',
	NOT_OK_HISTORY: 'kyc_not_ok_history',
};

export const BULK_OPERATIONS = {
	KYC_BANK_ACCOUNT: 'kyc_enable_bank_account',
	KYC_PAN_NUMBER: 'kyc_enable_bulk_pan_number',
};

export const ACCOUNTS = {
	ACCOUNT_SUMMARY: 'account_summary',
	AB_BUSINESS_INFO: 'ab_business_info',
	COMPLETE_LEDGER: 'complete_ledger',
	AB_REMAINING_BALANCE: 'ab_remaining_balance',
	AB_TDS_INFO: 'ab_tds_info',
	AB_PAN: 'ab_pan',
	REVERSE_PAYMENT: 'reverse_payment',
	AB_HOLDS: 'ab_holds',
	COMMISSION_CYCLE: 'commission_cycle',
	CASH_BONUS_CYCLE: 'cash_bonus_cycle',
	BUSINESS_PROCESSING: 'business_processing',
	GST_BUSINESS_PROCESSING: 'gst_business_processing',
	BENEFICIARY_DETAILS: 'beneficiary_details',
	BANK_BOOK_SUMMARY: 'bank_book_summary',
	BUSINESS_GENERATION: 'business_generation',
	MASTER_RCM_BANK: 'master_rcm_bank',
	AB_INVOICES: 'ab_invoices',
	HDFC_STATEMENT_UPLOAD: 'hdfc_statement_upload',
	HDFC_RESPONSE_UPLOAD: 'hdfc_response_upload',
	SAP_BUSINESS: 'sap_business',
	SAP_PAYMENT: 'sap_payment',
	AB_MISSING_PAN: 'ab_missing_pan',
	EXPORT_JOBS: 'export_jobs',
	MASTER_BUSINESS_REMARK: 'accounting_commission_remark',
	AB_LOAN_MANAGER: 'ab_loan_manager',
	ACCOUNTING_SAP_TDS: 'accounting_sap_tds',
	PAYMENT_RELEASE: 'payment_release',
};

export const MIS = {
	KYC_NOT_OK_REPORT: 'kyc_mis_not_ok_report',
	KYC_EXECUTIVE_PERFORMANCE_REPORT: 'kyc_mis_executive_performance_report',
	KYC_EXECUTIVE_CHECK_REPORT: 'kyc_mis_executive_check_report',
	KYC_MIS_DECLARATION_CHECK_REPORT: 'kyc_mis_declaration_check_report',
	KYC_MIS_BANK_AND_PAN_REPORT: 'kyc_mis_bank_pan_report',
	KYC_MIS_EMAIL_REPORT: 'kyc_mis_email_checking_report',
	KYC_MIS_MOBILE_REPORT: 'kyc_mis_mobile_checking_report',
	KYC_MIS_ID_PROOF_REPORT: 'kyc_mis_proof_checking_report',
	KYC_MIS_NAME_REPORT: 'kyc_mis_name_checking_report',
	KYC_MIS_INFO_REPORT: 'kyc_mis_info_checking_report',
	KYC_MIS_DAILY_UPDATE_SUMMARY: 'kyc_mis_daily_update_summary',
};

export const GENIE = {
	GENIE_MASTER_COMPANY_TARGET: 'genie_master_company_targets',
	GENIE_MASTER_ACTIVITY: 'genie_master_activity',
	GENIE_MASTER_ACTIVITY_TARGETS: 'genie_master_activity_targets',
	GENIE_MASTER_GMV: 'genie_master_gmv',
	GENIE_SETTINGS: 'genie_settings',
	GENIE_TARGET_REPORT: 'genie_target_report',
	GENIE_ACHIEVEMENT_REPORT: 'genie_achievement_report',
	GENIE_REVIEW_AND_APPROVAL: 'genie_review_and_approval',
	GENIE_MASTER_PILLAR_MAPPING: 'genie_master_pillar_mapping',
	GENIE_MASTER_SKILL_DEVELOPMENT_TARGETS: 'genie_master_skill_development_targets',
};

export const DRIVE_MODULE = {
	DRIVE_REVENUE_REPORT: 'drive_revenue_report',
	DRIVE_REVENUE_TARGET: 'drive_revenue_target',
	DRIVE_REACTIVATION_REPORT: 'drive_reactivation_report',
	DRIVE_MIS_REPORT: 'drive_mis_report',
	DRIVE_REPURCHASER_TARGET: 'drive_repurchaser_target',
	DRIVE_REPURCHASER_REPORT: 'drive_repurchaser_report',
};

export const PRODUCT_AVAILABILITY_TRACKING = 'product_availability_tracking';

export const KYC_HISTORY = {
	NAME_HISTORY: 'kyc_name_history',
	MOBILE_HISTORY: 'kyc_mobile_history',
	EMAIL_HISTORY: 'kyc_email_history',
	BANK_HISTORY: 'kyc_bank_history',
	PAN_HISTORY: 'kyc_pan_history',
	ADDRESS_HISTORY: 'kyc_address_history',
	IMAGE_HISTORY: 'kyc_image_history',
};

export const KYC_SEARCH_DETAIL = {
	BANK_ACC_NO: 'kyc_search_ab_bank',
	REG_MOBILE_NO: 'kyc_search_ab_mobile',
	AADHAR_NO: 'kyc_search_ab_aadhar',
	PAN_NO: 'kyc_search_ab_pan',
	STATE_NAME: 'kyc_search_ab_state_name',
	REFERENCE_NO: 'kyc_search_ab_reference',
	EMAIL_ID: 'kyc_search_ab_email_id',
	AB_DW_ASSOCIATION: 'kyc_search_ab_dw_ab_no',
	PHONE_MSG_HISTORY: 'kyc_sms_delivery_status',
};

export const KYC_REPORT_MODULE = {
	DETAIL_REPORT: 'kyc_report_detail_report',
	NOT_OK_REPORT: 'kyc_report_not_ok_report',
	DECLARATION_REPORT: 'kyc_reports_declaration_report',
	FEEDED_USER_WISE: 'kyc_report_feeded_user_wise',
	TERMINATE_AB: 'kyc_report_terminate_ab',
	NON_PURCHASING_AB_REPORT: 'kyc_report_non_purchasing_ab_report',
	AMOUNT_WISE_AB_COUNT: 'kyc_report_amount_wise_ab_count',
	SELF_PV_REPORT: 'kyc_report_self_pv_report',
	LIST_TERMINATE_REPURCHASE: 'kyc_list_terminate_repurchase',
	DEATH_CASE_REPORT: 'kyc_report_death_case_report',
	STOP_AB_REPORT: 'kyc_report_stop_ab_report',
	PIN_ACHIEVER_REPORT: 'kyc_report_pin_achiever_report',
	PIN_DASHBOARD: 'kyc_report_pin_dashboard',
	AB_LAST_6_MONTH_REPORT: 'kyc_report_ab_last_6_month_report',
	DIAMOND_CLUB_PURCHASE: 'kyc_report_diamond_club_purchase',
	STOP_TERMINATION: 'kyc_report_stop_termination',
	RED_KYC: 'kyc_report_red_kycs',
	KYC_AB_BULK_DETAILS: 'kyc_report_ab_bulk_details_report',
	PIN_GROWTH_ANALYSIS: 'kyc_pin_growth_analysis',
	KYC_AB_COMMISSION: 'kyc_ab_commission_report',
	UNETHICAL_JOINING_STOP: 'kyc_report_unethical_joining_stop',
};

export const KYC_DISABLE_INFO = {
	BANK_ACC_NO: 'kyc_disable_bank_account',
	PAN_NO: 'kyc_disable_pan_details',
};

export const CONFIGURATION = {
	SETTING: 'setting',
	MDM_SETTING: 'mdm_setting',
	MODULE_REMARK_MASTER: 'remarks_master',
	MODULE_REMARK_MODULE_MASTER: 'remarks_module_master',
};
export const KYC_ADMIN = {
	BULK_SMS: 'bulk_sms',
	UPDATE_GST: 'update_gst',
	AB_UNSTOP: 'kyc_ab_id_unstop',
	KYC_REPORTS_VIEW_LOGS: 'kyc_reports_view_logs',
	INCREASE_MOBILE_COUNT: 'increase_mobile_count',
	UPDATE_MOBILE_COUNT: 'kyc_associate_buyer_update_mobile_count',
	MASTERS: 'kyc_admin_masters',
	MASTER_PIN_DESCRIPTION: 'master_pin_description',
	MASTER_DOCUMENTS: 'master_documents',
	MASTER_DEPARTMENT_LIST: 'master_department_list',
	MASTER_KYC_REASON_DESC: 'master_kyc_reason_desc',
	MASTER_COMPANY_LIST: 'master_company_list',
	MASTER_DIAMOND_CLUB: 'master_diamond_club',
	MASTER_RELATIONS: 'master_relations',
	MASTER_OCCUPATIONS: 'master_occupations',
	EXCEPTIONAL_CASES: 'kyc_exceptional_cases',
};

export const DEATH_CASE = {
	OLD: 'old',
	NEW: 'new',
};

export const dobDefaultDate = dayjs().subtract(18, 'year').subtract(1, 'day');

export const udaanBatchLanguages = [
	{label: 'English', value: 'english'},
	{label: 'Hindi', value: 'hindi'},
	{label: 'Assamese', value: 'assamese'},
	{label: 'Malayalam', value: 'malayalam'},
	{label: 'Tamil', value: 'tamil'},
	{label: 'Telugu', value: 'telugu'},
	{label: 'Kannada', value: 'kannada'},
	{label: 'Bengali', value: 'bengali'},
];

export const ROLE_TYPE = {
	SUPER_ADMIN: 'Super Admin',
};

// Credit to puc ledger entry types
export const LEDGER_ENTRY_TYPES = {
	CREDIT: 'credit',
	DEBIT: 'debit',
};

// Define constants for slugs
export const E_REGISTRATION_EDIT_SLUG = 'e_registration_edit';
export const E_REGISTRATION_SLUG = 'e_registration';
export const OLD_KYC_SLUG = 'old_kyc';
export const DEC_YES_KYC_SLUG = 'declaration_yes_kyc';

export const NOT_OK_BY_SYSTEM_SLUG = 'not_ok_kyc`s_tonight';
export const NOT_OK_BY_ADMIN_SLUG = 'not_ok_admin_kyc';

export const OK_BY_SYSTEM_SLUG = 'ok_kyc`s_tonight'; // Kyc`s which are auto verified by the system
export const AUTO_CHECK_SLUG = 'auto_check_kyc'; // Kyc`s which are auto verified by the system
export const OK_KYC_BY_ADMIN = 'ok_kyc_by_admin';
export const EKYC_SLUG_NOT_KYC_BEFORE_2018 = 'not_ok_kycs_before_2018';

export const KYC_RECEIVE_CHECK_01_DEC_2018 = '2018-12-01';

export const FILE_EXTENSION_LIST = ['xlsx', 'xls', 'csv'];
export const ALL_VARS = ['var1', 'var2', 'var3', 'var4', 'var5'];

export const DUPLICATE_KEYS = {
	PAN: 'pan',
	MOBILE: 'mobile',
	BANK: 'bank',
};
export const MODULE_STATUS = {ACTIVE: 'active', INACTIVE: 'inactive'};

export const USER_MANAGEMENT = {MANAGE_MODULES: 'manage_modules'};

export const GST_ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];

export const MODULE_TYPES = {
	KYC_VERIFICATION: 'kyc-verification',
};

export const FORM_TITLES = {
	BANK_ACCOUNT_INFO: 'Bank Account Info',
};

export const pincode_status_remark = [
	{
		label: 'Permanent',
		value: 'permanent',
	},
	{
		label: 'Temporary',
		value: 'temporary',
	},
];

export const MASTER_AB_DETAIl = 'master-ab-detail';
export const startYear = 2025;

export const ExecutiveFeedbackReport = 'executive-feedback-report';

export const UTILITY = {
	SCHEDULE_MANAGEMENT: 'schedule_management',
	MANAGE_AB_LOGIN: 'manage_ab_login',
};

export const BUSINESS_MODULES = {
	BUSINESS_GENERATION: 'business_generation',
	CONSISTENCY_DATA: 'consistency_data',
	CASH_BONUS_DATA: 'cash_bonus_data',
	FINAL_CASH_BONUS: 'final_cash_bonus',
	FINAL_RCM_CONSISTENCY: 'final_rcm_consistency',
};

// Schedule Management Constants
export const SCHEDULE_TYPES = {
	MODULE_SPECIFIC: 'module-specific',
	FEATURE_SPECIFIC: 'feature-specific',
};

export const RECURRENCE_TYPES = {
	ONE_TIME: 'one-time',
	DAILY: 'daily',
	WEEKLY: 'weekly',
	MONTHLY: 'monthly',
};

export const SCHEDULE_STATUSES = {
	PENDING: 'pending',
	ACTIVE: 'active',
	COMPLETED: 'completed',
	CANCELLED: 'cancelled',
	FAILED: 'failed',
};

export const SCHEDULABLE_FEATURES = [
	{
		value: 'ecom-maintenance',
		label: 'E-commerce Maintenance Mode',
		description: 'Enable maintenance mode for the entire e-commerce platform',
	},
];

export const ACTION_TYPE_OPTIONS = [
	{label: 'Enabled', value: 'Enabled'},
	{label: 'Disabled', value: 'Disabled'},
	{label: 'Rejected', value: 'Rejected'},
	{label: 'Approved', value: 'Approved'},
];

export const MIS_PROOF_CHECK_OPTIONS = [
	{label: 'AB Photo', value: 'profile_photo'},
	{label: 'Identity Proof & Address Proof', value: 'address_and_id_proof'},
	{label: 'Old KYC Check', value: 'existing_form'},
];

export const MIS_REPORT_CONFIG = {
	profile_photo: {
		fileName: 'ab-photo-report',
		reportType: 'AB Photo Report',
	},
	address_and_id_proof: {
		fileName: 'id-address-proof-report',
		reportType: 'Identity & Address Proof Report',
	},
	existing_form: {
		fileName: 'old-kyc-check-report',
		reportType: 'Old KYC Check Report',
	},
};

export const KYC_REQUEST_TYPES = {
	BANK: 'bank-update-request',
	PAN: 'pan-update-request',
	MOBILE: 'mobile-update-request',
	STOP: 'stop-unstop-track',
};

export const KYC_UPDATE_REQUEST = {
	BANK: 'kyc_update_request_bank',
	PAN: 'kyc_update_request_pan',
	MOBILE: 'kyc_update_request_mobile',
};

export const WALLET_MODULE = {
	LIST: 'wallet_list',
	MAPPED: 'mapped_list',
	REMAINING_BALANCE: 'wallet_remaining_balance',
};

// Page Zize for pagination
export const PAGE_SIZE = 10;

// Max range days for date filters
export const MAX_RANGE_DAYS = 7;

// Branch Validation Constants
export const BRANCH_VALIDATION_REGEX = {
	NO_EDGE_SPACE: /^\S(.*\S)?$/,
	CONSECUTIVE_SPACE: /^(?!.*\s{2,}).*$/,
	IFSC_CODE: /^[A-Z]{4}0[A-Z0-9]{6}$/,
	BRANCH_NAME: /^[A-Za-z0-9,\s]+$/,
};

// Branch Validation Messages
export const BRANCH_VALIDATION_MESSAGES = {
	IFSC_REQUIRED: 'IFSC Code is required',
	BRANCH_NAME_REQUIRED: 'Branch Name is required',
	BRANCH_ADDRESS_REQUIRED: 'Branch Address is required',
	INVALID_IFSC_CODE: 'Enter valid IFSC code',
	ALLOWED_BRANCH_NAME: 'Only letters, numbers, spaces and comma (,) are allowed',
};

export const MAX_FILE_SIZE_MB = 5;

export const MAX_AB_ID_ALLOWED = 10000;

export const IGNORED_AB_IDS_BELOW = 10000;

export const storeRecipient = [
	{
		label: 'All',
		value: 'all',
	},
	{
		label: 'Store Code',
		value: 'store_code',
	},
	{
		label: 'Store Type',
		value: 'store_type',
	},
	{
		label: 'Hyper Local',
		value: 'is_hlcl',
	},
];

export const STORE_CODE_DATA = [{'store code': 111}, {'store code': 222}];

export const DOWNLOAD_RECIPIENT_TYPES = ['A', 'D', 'K', 'Q', 'T', 'W', 'X', 'Y', 'PP', 'P', 'PT'];

// create return constant
export const BILL_TYPE = {
	RETURN: 'RETURN',
};

export const REVIEW_AND_APPROVAL_STATUS = {
	APPROVED: 'approved',
	REJECTED: 'rejected',
};

export const REVIEW_AND_APPROVAL_EVENT_STATUS = {
	PENDING: 'pending',
	UNDER_REVIEW: 'under_review',
	COMPLETED: 'completed',
	REJECTED: 'rejected',
};

// KYC Image History document types and date/time formats
export const KYC_DOC_TYPE_KEYS = {
	APPLICANT_PHOTO: 'applicant_photo',
	IDENTITY_PROOF: 'identity_proof',
	ADDRESS_PROOF: 'address_proof',
	BANK_PROOF: 'bank_proof',
	PAN_PROOF: 'pan_proof',
};

export const KYC_DOC_TYPE_LABELS = {
	[KYC_DOC_TYPE_KEYS.APPLICANT_PHOTO]: 'Applicant Photo',
	[KYC_DOC_TYPE_KEYS.IDENTITY_PROOF]: 'Identity Proof',
	[KYC_DOC_TYPE_KEYS.ADDRESS_PROOF]: 'Address Proof',
	[KYC_DOC_TYPE_KEYS.BANK_PROOF]: 'Bank Proof',
	[KYC_DOC_TYPE_KEYS.PAN_PROOF]: 'PAN Proof',
};

export const KYC_DATE_FORMATS = {
	DATE_FORMAT: 'DD MMM YYYY',
	TIME_FORMAT: 'hh:mm A',
};

export const PAN_NUMBER_LABEL = 'PAN Number';
export const PAN_NO_KEY = 'pan_no';

export const KYC_ACCOUNTS = {
	BUSINESS_ENTRY: 'kyc_business_entry',
	PAYMENT_ENTRY: 'kyc_payment_entry',
	JV_ENTRY: 'kyc_jv_entry',
};

export const DATE_FORMAT_TYPES = {
	MONTH_FORMAT: 'DD/MMM/YYYY',
	SLASH_DATE: 'DD / MM / YYYY',
	RANGE_FORMAT: 'DD-MM-YYYY',
	TIME_RANGE_FORMAT: 'DD-MM-YYYY HH:mm:ss',
	MAINTENANCE_TIME: 'DD-MM-YYYY hh:mm A',
	MEETING_TIME: 'DD-MM-YYYY hh:mm A',
	COMMON_FORMAT: 'YYYY-MM-DD',
	TIME_FORMAT: 'hh:mm a',
	MONTH_RANGE: 'MMM',
	TICKET_MODULE_FORMAT: 'DD/MMM/YYYY  hh:mm a ',
};

export const BANK_BOOK_STATUS = {
	CLEARED: 'Cleared',
	FAILED: 'Failed',
	PENDING: 'Pending',
	REVERSED: 'Reversed',
};

export const BANK_CODES = {
	SBI: 115,
	HDFC: 129,
	CANARA: 106,
};

export const BANK_TYPES = {
	SBI_SBI: 'SBI - SBI',
	SBI_OTHER: 'SBI - Other',
};

// Eligible Priority offer info
export const ELIGIBLE_PRIORITY_OFFER_INFO = [
	{
		label: 'How to decide priority ?',
		text: 'If stock is available in both or All SAP codes, only one tester should be shown.In case both/all SAP codes have stock in PUC, old SAP code should be given priority and shown first.',
	},
	{
		label: 'How to apply priority ?',
		text: 'When you drag a product and set to no. 1 in priority list and If PUC has both the products avaiable, Only the first product will be visible and eligible for buying. Otherwise If PUC have any one of the listed product in stock that will be eligible for buying.',
	},
];

// offer upload fields
export const PRODUCT_TO_GET_FREE_SAMPLE = [
	{
		'SAP Code': '100001',
		'Product Name': 'Sample Product',
	},
];
export const BUYER_REPURCHASE_SEARCH_TYPES = {
	PROPOSER: 'proposer',
	MOBILE: 'mobile',
};

export const INV_TYPE = {
	COMMISSION: 'COMMISSION',
	CASH_BONUS: 'CASH_BONUS',
};

export const invoiceTypeOptions = [
	{label: 'Incentive', value: INV_TYPE.COMMISSION},
	{label: 'Cash Bonus', value: INV_TYPE.CASH_BONUS},
];

export const financialYearMonths = [
	{label: 'April', value: 4},
	{label: 'May', value: 5},
	{label: 'June', value: 6},
	{label: 'July', value: 7},
	{label: 'August', value: 8},
	{label: 'September', value: 9},
	{label: 'October', value: 10},
	{label: 'November', value: 11},
	{label: 'December', value: 12},
	{label: 'January', value: 1},
	{label: 'February', value: 2},
	{label: 'March', value: 3},
];

// INFO For Avaialbility section in Products Module
export const SUPPORTED_STORES_INFO = [
	{
		label: 'Availability',
		text: 'This product will only be available on the Stores for the selected store types.',
	},
];

export const ECOM_BUYER_TYPE_INFO = [
	{
		label: 'Availability',
		text: 'This product will only be available to the specific E-Com users selected below.',
	},
];

export const ACCOUNTING_BUSINESS_PROCESSING_MODES = {
	AUTO: 'Auto',
	MANUAL: 'Manual',
};

export const POS_BUYER_TYPE_INFO = [
	{
		label: 'Availability',
		text: 'This product will only be available for billing for the selected Buyer Type. If the same E-Com user types are not selected here, the product will only be purchasable through online orders.',
	},
];

// Supported redirection page types for mobile app banners including direct page value navigation
export const appPageType = [
	{label: 'Listing', value: 'listing'},
	{label: 'Product Details', value: 'product_details'},
	{label: 'Static', value: 'static'},
	{label: 'Page Value', value: 'page_value'},
];

export const appListingType = [
	{label: 'Brand', value: 'brand'},
	{label: 'Category', value: 'category'},
];

export const appStaticScreens = [
	// Bottom tabs
	{label: 'Home', value: 'root'},
	{label: 'Shop', value: 'product-list'},

	// World of RCM
	{label: 'Aparajita', value: 'aparajita-listing'},
	{label: 'Delivery Centers', value: 'delivery-center'},
	{label: 'Downloads', value: 'downloads'},
	{label: 'Media', value: 'media'},
	{label: 'RCM Events', value: 'rcm-event'},

	// Associate Buyer
	{label: 'Message for Associate Buyer', value: 'message-for-ab'},
	{label: 'Associate Buyer Info', value: 'ab-info'},
	{label: 'E-KYC Application for New A.B.', value: 'kyc-add'},
	{label: 'E-KYC Verification', value: 'kyc-verification'},
	{label: 'Application For Existing Associate Buyer', value: 'kyc-existing-ab-verification'},
	{label: 'E-KYC Application Corrections', value: 'kyc-correction-verification'},
	{label: 'Application Form Status', value: 'kyc-status'},
	{label: 'ID Activation Status', value: 'id-activation'},
	{label: 'Fill your Bank Account Detail', value: 'bank-detail-update'},
	{label: 'Fill your PAN Details', value: 'pen-detail-update'},
	{label: 'Mobile Number Change', value: 'mobile-number-change'},
	{label: 'Correction Form For Existing Associate Buyer', value: 'kyc-existing-correction-ab-verification'},

	// Activities
	{label: 'Blood Donor', value: 'blood-donor'},
	{label: 'Plantation', value: 'plantation'},

	// Help & Support
	{label: 'Customer Grievance Redressal', value: 'grievance-redressal'},
	{label: 'Contact Us', value: 'contact-us'},
	{label: 'FAQs', value: 'faq'},
	{label: 'Term & Conditions', value: 'terms-and-conditions'},
	{label: 'Privacy Policy', value: 'privacy-policy'},
];
